// Web token storage. Mirrors the mobile app's `src/apis/storage.js` API (same
// function names) so logic ports cleanly, but backs onto localStorage instead
// of expo-secure-store. localStorage is synchronous, so these are sync.

const TOKEN_KEY = "token";

export const storeToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const deleteToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

// Decode the JWT payload (just `{ _id, iat, exp }`) without a dependency — the
// token's middle segment is base64url-encoded JSON.
export const getDecodedToken = () => {
  const token = getToken();
  if (!token) return null;
  try {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
};

// True if a token exists and has not expired.
export const hasValidToken = () => {
  const decoded = getDecodedToken();
  if (!decoded) return false;
  if (decoded.exp && Date.now() >= decoded.exp * 1000) return false;
  return true;
};

export const signOut = () => {
  deleteToken();
};
